<template>
	<div>
		<main><router-view /></main>
	</div>
</template>

<script>
export default {
	name: 'LandingLayout',
}
</script>

<style scoped></style>
